import { formatJson } from "./jsonFormatter";
import { formatXml } from "./xmlFormatter";
import { formatHtml } from "./htmlFormatter";
import { BodyContentType } from "../constants/restRequestConstants";

export function formatResponse(response) {

  console.log("Formatting response:", response);

  const contentType = response.contentType;
  let formattedData = response.data;

  if (response.isBinary) {
    formattedData = "[File]";
    formattedData += `\nSize: ${response.size} bytes`;
    formattedData += `\nFilename: ${response.filename || "unknown"}`;
    formattedData += `\nFile Extension: ${response.fileExtension || "unknown"}`;
    formattedData += `\nContent Type: ${contentType || "unknown"}`;
  } else {
    try {
      if (contentType.includes(BodyContentType.JSON)) {
        formattedData = formatJson(response.data);
      } else if (contentType.includes("xml")) {
        formattedData = formatXml(response.data);
      } else if (contentType.includes("html")) {
        formattedData = formatHtml(response.data);
      }
    } catch (error) {
      console.error("Error formatting response:", error);
      formattedData = response.data;
    }
  }

  return {
    data: formattedData,
    statusCode: response.status,
    statusText: response.statusText,
    duration: response.duration,
    size: response.size,
    headers: response.headers,
    cookies: response.cookies,
    contentType,
    isBinary: response.isBinary,
    fileExtension: response.fileExtension,
    filename: response.filename || `file${response.fileExtension ? `.${response.fileExtension}` : ""}`,
  };
}

export function formatHeadersForCopy(headers) {
  return Object.entries(headers)
    .map(([key, value]) => `${key}: ${value}`)
    .join("\n");
}

export function formatCookiesForCopy(cookies) {
  return cookies
    .map((cookie) => {
      const details = [
        `${cookie.name}=${cookie.value}`,
        cookie.domain && `Domain=${cookie.domain}`,
        cookie.path && `Path=${cookie.path}`,
        cookie.expires && `Expires=${new Date(cookie.expires).toISOString()}`,
        cookie.httpOnly && "HttpOnly",
        cookie.secure && "Secure",
      ].filter(Boolean);
      return details.join("; ");
    })
    .join("\n");
}
